import { connect } from 'react-redux'
import { getUserDto, isAuthenticated, isResetPasswordInProgress } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { IDispatchProps, IStateProps, SignUp } from './SignUp'
import { doSignUp } from './store/SignUpActions'
import { reLocate } from '../../common/Routes/RouterActions'
import { getSignUpLastUpdate } from './store/SignUpSelectors'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  authenticated: isAuthenticated(state),
  resetPasswordInProgress: isResetPasswordInProgress(state),
  userDto: getUserDto(state),
  lastUpdate: getSignUpLastUpdate(state),
})

const mapDispatchToProps: IDispatchProps = {
  doSignUp,
  reLocate,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)
